// Wheel constants — shared across PIESection + LegRow + ModeBRow.
export const STRAT_COLORS = {
  CSP: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  BPS: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  BCS: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  DCS: "bg-yellow-500/10 text-yellow-500 border-yellow-500/20",
  CC:  "bg-purple-500/10 text-purple-400 border-purple-500/20",
  // Iter142: JL — teal to distinguish from BCS orange (JL shares the BCS
  // short-call-spread leg but the put anchors the risk profile).
  JL:  "bg-teal-500/10 text-teal-400 border-teal-500/20",
};
export const STRAT_ALL = ["All", "CSP", "BPS", "BCS", "CC", "DCS", "JL"];
